import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import { colors } from '../theme';

import HoverMenu from './hover-menu';
import Dropdown from './dropdown';
import CategoryDropdown from './category-dropdown';
import data from './data';

const GA_CATEGORY = 'Header Menu';

//nav list for desktop
export const DesktopNav = styled.ul`
  margin-bottom: 0;
  margin-top: 0;
  text-align: left;
  display: inline-block;
  padding: 16px 0;
  vertical-align: top;
`;

//use same stlying for mobile and desktop nav links
export const NavLink = styled.a`
  font-size: 15px;
  color: #333;
  text-decoration: none;
  color: ${colors.MEDIUM_DARK_GREY};
  padding: 10px 20px 10px 0;
  display: inline-block;
  &:hover,
  &:visited {
    color: #555;
  }

  ${props =>
    props.primary &&
    css`
      color: ${props.theme.primary};
      &:hover,
      &:visited {
        color: ${props.theme.primary};
      }
    `};
`;

export default class HeaderLinks extends Component {
  static propTypes = {
    isHomepage: PropTypes.bool,
    siteSource: PropTypes.string
  };

  state = {
    location: null
  };

  render() {
    const { siteSource, isHomepage } = this.props;

    return (
      <DesktopNav isHomepage={isHomepage} data-label={'header-links'}>
        <HoverMenu
          pointOffset="85px" /* where the pointy bit on top of hover menu should be positioned */
          menuItem={
            <NavLink
              style={{}}
              href="/find"
              data-ga-category={GA_CATEGORY}
              data-ga-action={`${GA_CATEGORY} - Clicked Trade Categories`}
              data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
              data-ga-hover-action={`${GA_CATEGORY} - Hover Trade Categories`}
            >
              Trades
            </NavLink>
          }
        >
          <CategoryDropdown
            categories={data.categories}
            popularCategories={data.popularCategories}
            siteSource={siteSource}
          />
        </HoverMenu>
        <HoverMenu
          pointOffset="85px"
          menuItem={
            <NavLink
              href="/photos"
              data-ga-category={GA_CATEGORY}
              data-ga-action={`${GA_CATEGORY} - Clicked Browse Photos`}
              data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
              data-ga-hover-action={`${GA_CATEGORY} - Hover Browse Photos`}
            >
              Photos
            </NavLink>
          }
        >
          <Dropdown
            items={data.photoCategories}
            footer={{
              key: '/photos',
              value: 'View all photo categories',
              desc: 'Photo'
            }}
            siteSource={siteSource}
            sourceType="Photos"
          />
        </HoverMenu>
        <HoverMenu
          pointOffset="88px"
          menuItem={
            <NavLink
              href="/articles"
              data-ga-category={GA_CATEGORY}
              data-ga-action={`${GA_CATEGORY} - Clicked Articles`}
              data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
              data-ga-hover-action={`${GA_CATEGORY} - Hover Articles`}
            >
              Articles
            </NavLink>
          }
        >
          <Dropdown
            items={data.articleCategories}
            footer={{
              key: '/articles',
              value: 'View all article topics',
              desc: 'Article'
            }}
            siteSource={siteSource}
            sourceType="Topics"
          />
        </HoverMenu>
        <HoverMenu
          pointOffset="103px"
          menuItem={
            <NavLink
              href="/c/cost"
              data-ga-category={GA_CATEGORY}
              data-ga-action={`${GA_CATEGORY} - Clicked Cost Guides`}
              data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
              data-ga-hover-action={`${GA_CATEGORY} - Hover Cost Guides`}
            >
              Cost Guides
            </NavLink>
          }
          style={{ paddingRight: 0, paddingBottom: 0 }}
        >
          <Dropdown
            items={data.costGuides}
            footer={{
              key: '/articles',
              value: 'View all cost guides',
              desc: 'Cost Guide'
            }}
            siteSource={siteSource}
            sourceType="Cost Guides"
          />
        </HoverMenu>
      </DesktopNav>
    );
  }
}
